import * as React from "react";

import { use100vh } from "../hooks";

import {
  usePlpPresenterForTheFilterMenu_Mobile,
  useProductListPresentationModelFacets,
} from "../providers";

import { SubMenu } from "./SubMenu";
import { MainMenu } from "./MainMenu";
import { Header } from "./Header";

interface ContentProps {
  onClose: () => void;
}

export const Content: React.FunctionComponent<ContentProps> = (props) => {
  const { onClose } = props;

  const { presentationFacets } = useProductListPresentationModelFacets();

  const { whatIsTheExclusivelyOpenFilterSubMenuRightNow_onMobile } =
    usePlpPresenterForTheFilterMenu_Mobile();

  const height = use100vh();

  const [presentedFilterSubMenu, setPresentedFilterSubMenu] = React.useState(
    whatIsTheExclusivelyOpenFilterSubMenuRightNow_onMobile
  );
  const [presentSubMenuAnimation, setPresentSubMenuAnimation] =
    React.useState(false);

  React.useEffect(() => {
    if (
      !whatIsTheExclusivelyOpenFilterSubMenuRightNow_onMobile &&
      presentedFilterSubMenu
    ) {
      // close
      setPresentSubMenuAnimation(false);
      setTimeout(() => {
        setPresentedFilterSubMenu(undefined);
        setPresentSubMenuAnimation(false);
      }, 299);
    } else if (
      whatIsTheExclusivelyOpenFilterSubMenuRightNow_onMobile &&
      presentedFilterSubMenu &&
      whatIsTheExclusivelyOpenFilterSubMenuRightNow_onMobile !==
        presentedFilterSubMenu
    ) {
      // override
      setPresentedFilterSubMenu(
        whatIsTheExclusivelyOpenFilterSubMenuRightNow_onMobile
      );
      window.requestAnimationFrame(() => {
        setPresentSubMenuAnimation(true);
      });
    } else if (
      whatIsTheExclusivelyOpenFilterSubMenuRightNow_onMobile &&
      !presentedFilterSubMenu
    ) {
      // open
      setPresentSubMenuAnimation(false);
      setPresentedFilterSubMenu(
        whatIsTheExclusivelyOpenFilterSubMenuRightNow_onMobile
      );
      window.requestAnimationFrame(() => {
        setPresentSubMenuAnimation(true);
      });
    }
  }, [
    whatIsTheExclusivelyOpenFilterSubMenuRightNow_onMobile,
    presentedFilterSubMenu,
  ]);

  const subMenus = React.useMemo(() => {
    return presentationFacets.map((facet) => {
      const shouldPresent =
        presentedFilterSubMenu &&
        presentedFilterSubMenu.key === facet.key &&
        presentSubMenuAnimation;
      return (
        <div
          key={facet.key}
          className={`sub-menu ${shouldPresent ? "present" : ""}`}
          style={{
            height: height ? `calc(${height}px - 75px)` : "calc(100vh - 75px)",
          }}
        >
          <Header
            whatIsTheExclusivelyOpenFilterSubMenuRightNow_onMobile={facet}
            onCloseModal={onClose}
          />
          <SubMenu
            whatIsTheExclusivelyOpenFilterSubMenuRightNow_onMobile={facet}
          />
        </div>
      );
    });
  }, [
    whatIsTheExclusivelyOpenFilterSubMenuRightNow_onMobile,
    presentationFacets,
    presentedFilterSubMenu,
    presentSubMenuAnimation,
    height,
  ]);

  return (
    <div className="content">
      <div
        className="main-menu"
        style={{
          height: height ? `calc(${height}px - 75px)` : "calc(100vh - 75px)",
        }}
      >
        <Header onCloseModal={onClose} />
        <MainMenu />
      </div>

      {subMenus}
    </div>
  );
};
